export default "__VITE_ASSET__DMbu12l$__"